import React from 'react';
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd';
import { DatePickerProps } from 'antd';
import moment from "moment";
import "moment/locale/ko";
import locale from "antd/lib/locale/ko_KR";
import { isMobile } from 'react-device-detect';

type CustomDatePickerProps = DatePickerProps & {
  width?: string;
};

const DatePicker = ({width='auto', ...rest }: CustomDatePickerProps): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <ConfigProvider locale={locale}>
      <AntdDatePicker
        {...rest}
        style={{width:(isMobile && rest.picker == 'month') ? '95px': width}}
      />
    </ConfigProvider>
  );
};

export default DatePicker;
